'use client'

import React from 'react'
import Link from 'next/link'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/react'
import { ChevronDown, LogOut, QrCode } from 'lucide-react'
import { signOut } from 'next-auth/react'

type Props = {
  displayName: string
  initials: string
}

export default function UserMenu({ displayName, initials }: Props) {
  return (
    <div className="flex items-center space-x-2">
      <Menu as="div" className="relative">
        <MenuButton className="flex items-center space-x-2 focus:outline-none">
          <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center cursor-pointer text-xs font-semibold text-gray-800">
            {initials || 'U'}
          </div>
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </MenuButton>

        <MenuItems className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-10 focus:outline-none py-1 animate-fade-in">
          <div className="px-4 py-2 text-sm font-semibold text-gray-900 border-b border-gray-100">
            {displayName}
          </div>

          <MenuItem>
          {/* TODO: Link to admin view */}
            {({ active }) => (
              <div
                //href="/utilisateurs"
                className={`block px-4 py-2 text-sm transition-colors ${
                  active ? 'bg-gray-100 text-blue-700' : 'text-gray-700'
                }`}
              >
                Vue administration
              </div>
            )}
          </MenuItem>
          <MenuItem>
            {/* TODO: Link to user personal view */}
            {({ active }) => (
              <div
                //href="/mon-compte"
                className={`block px-4 py-2 text-sm transition-colors ${
                  active ? 'bg-gray-100 text-blue-700' : 'text-gray-700'
                }`}
              >
                Vue personnelle
              </div>
            )}
          </MenuItem>

          <div className="border-t border-gray-100 my-1" />

          <MenuItem>
            {({ active }) => (
              <button
                onClick={() => signOut()}
                className={`w-full flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-colors 
                ${active ? 'bg-red-50 text-red-700' : 'text-red-600 hover:bg-red-50'}`}
              >
                <LogOut className="w-4 h-4" />
                Déconnexion
              </button>
            )}
          </MenuItem>
        </MenuItems>
      </Menu>
    </div>
  )
}
